import * as React from 'react';
import { Link } from 'react-router-dom';
import { Button } from '../../../web/components-v2/Button';

const NewTabLink: React.FC<React.PropsWithChildren<{ to: string }>> = ({ to, children }) => (
	<Button asChild variant='secondary' size='sm'>
		<Link to={to} target='_blank' rel='noopener noreferrer'>
			{children}
		</Link>
	</Button>
);

export const ReviewLink: React.FC<{ aiConversationId?: string }> = ({ aiConversationId }) =>
	aiConversationId ? (
		<NewTabLink to={`/ai-coaching-review?convo=${aiConversationId}`}>Open in review</NewTabLink>
	) : null;

export const CallLogLink: React.FC<{ phoneCallId?: string }> = ({ phoneCallId }) =>
	phoneCallId ? <NewTabLink to={`/call-log/${phoneCallId}`}>Call Log</NewTabLink> : null;
